import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { css } from 'emotion';
import _ from 'lodash';

import Checkbox from '~/modules/coreUI/components/basic/Checkbox';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';

import PackageVariantsContext from '../packageVariantsContext';

const Container = styled.div`
  display: flex;
  direction: row;
  flex-wrap: wrap;

  width: 100%;

  background-color: ${props => props.theme.new.colors.backgrounds.panel};
  border-radius: ${props => props.theme.new.borders.radius.lg}px;
`;

const CheckContainer = styled.div`
  min-width: calc(50% - 6px);
  flex-grow: 1;
  padding: 3px;
  margin: 3px;

  background-color: ${props => props.theme.new.colors.named.inverted};

  border-style: solid;
  border-color: ${props => props.theme.new.colors.named.secondary};
  border-width: ${props => props.theme.new.borders.size.thin}px;
  border-radius: ${props => props.theme.new.borders.radius.xl}px;

  ${props => props.disabled && css`
    opacity: 0.3;
    border-color: ${props.theme.new.colors.labels.borders.normal.subtle};
  `}
`;

const labelStyles = () => css`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

class PackageVariants extends Component {
  state = {
    recordedVariants: {},
  }

  isChecked = (selectedVariants, variantId) => {
    if (Object.prototype.hasOwnProperty.call(selectedVariants, variantId)) {
      return !!selectedVariants[variantId];
    }
    return false;
  }

  isDisabled = (selectedVariants, variantId) => {
    const isChecked = this.isChecked(selectedVariants, variantId);
    return !isChecked && this.state.selectedVariantsCounter >= this.props.requiredServicesAmount;
  }

  handleOnChange = currentVariant => ((variantStatus) => {
    this.setState(prevState => ({
      recordedVariants: {
        ...prevState.recordedVariants,
        [currentVariant.ref_id]: variantStatus,
      },
    }), () => {
      this.setState(prevState => ({
        selectedVariantsCounter: _.size(_.filter(prevState.recordedVariants, x => x === true)),
      }), () => {
        this.context.selectVariants(Object.entries(this.state.recordedVariants).filter(x => x[1] === true).map(x => x[0]));
      });
    });
  })

  render = () => (
    <Fragment>
      <Label primary semiBold md>{`Select ${this.props.requiredServicesAmount} services`}</Label>
      <Spacer size={1} />
      <Container>
        {this.props.variantServices.map(variant => (
          <CheckContainer disabled={this.isDisabled(this.state.recordedVariants, variant.ref_id)}>
            <Checkbox
              secondary
              fullRound
              label_nowrap
              label_emphasized
              label_customStyle={labelStyles}
              label={variant.name}
              disabled={this.isDisabled(this.state.recordedVariants, variant.ref_id)}
              checked={this.isChecked(this.state.recordedVariants, variant.ref_id)}
              onChange={this.handleOnChange(variant)}
            />
          </CheckContainer>
        ))}
      </Container>
    </Fragment>
  )
}

PackageVariants.contextType = PackageVariantsContext;

PackageVariants.propTypes = {
  variantServices: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  requiredServicesAmount: PropTypes.number.isRequired,
};

export default PackageVariants;
